
export interface Profile {
  id: string;
  username: string;
  full_name: string | null;
  avatar_url: string | null;
  bio: string | null;
  location: string | null;
  accountability_goal: string | null;
  areas_of_interest: string[];
  preferred_frequency: 'daily' | 'weekly' | 'bi-weekly' | 'monthly' | null;
  is_public: boolean;
  created_at: string;
  updated_at: string;
}

export interface Friendship {
  id: string;
  requester_id: string;
  addressee_id: string;
  status: 'pending' | 'accepted' | 'declined' | 'blocked';
  created_at: string;
  updated_at: string;
  requester?: Profile;
  addressee?: Profile;
}

export interface Task {
  id: string;
  owner_id: string;
  title: string;
  description: string | null;
  due_date: string | null;
  due_time: string | null;
  category: string;
  status: 'pending' | 'in_progress' | 'completed' | 'cancelled';
  priority: 'low' | 'medium' | 'high';
  tagged_partners: string[];
  created_at: string;
  updated_at: string;
  owner?: Profile;
}

export interface Conversation {
  id: string;
  participant1_id: string;
  participant2_id: string;
  last_message_at: string;
  created_at: string;
  participant1?: Profile;
  participant2?: Profile;
  last_message?: Message;
}

export interface Message {
  id: string;
  conversation_id: string;
  sender_id: string;
  content: string | null;
  image_url: string | null;
  message_type: 'text' | 'image' | 'mixed' | 'task_tag';
  is_read: boolean;
  created_at: string;
  sender?: Profile;
}

export const AREAS_OF_INTEREST = [
  'Fitness & Health',
  'Career & Business',
  'Education & Learning',
  'Creative Arts',
  'Finance & Savings',
  'Mental Wellness',
  'Nutrition & Diet',
  'Side Projects',
  'Language Learning',
  'Reading & Writing',
  'Entrepreneurship',
  'Personal Development',
];

export const FREQUENCIES = [
  { value: 'daily', label: 'Daily' },
  { value: 'weekly', label: 'Weekly' },
  { value: 'bi-weekly', label: 'Bi-Weekly' },
  { value: 'monthly', label: 'Monthly' },
];

export const TASK_CATEGORIES = [
  'personal',
  'fitness',
  'career',
  'education',
  'finance',
  'health',
  'creative',
  'other',
];
